const TABLETBREAK = 900;
const MAXWRAP = 1400;
const BANKNAME = "Legend Bank";
const CONTACTLINK = "/about-us/contact/";